module.exports = __webpack_public_path__ + "img/aigod_aigodtokenwx.a7ad809.png";